import React, { useEffect, useState } from 'react';

import { Button } from 'antd';
import Scrollbar from 'react-custom-scrollbars';
import { useTimeout, useSetState  } from 'ahooks';
import LoginModal from './LoginModal';
import { useHistory } from 'react-router';
import * as Cookie from '@/utils/cookie';
import { useActions } from '@/utils/hooks';

import './index.scss';
import ContactModal from './ContactModal';
import PAGES from '@/constants/page';
import Header from '@/layout/Header/Header';
import common from '@/api/common';
import Mobile from './Mobile/Mobile';
import audiobookapi from '@/api/audiobookapi';

import { SCREEN_WIDTH } from '@/constants/common';
import DubWarp from './DubWarp';
import ServiceWarp from './ServiceWarp';
import classNames from 'classnames';

export default function AiBookHomePage() {

  const history = useHistory();
  const actions = useActions(({ user }) => ({ user }));
  const [openLogin, setOpenLogin] = useState(false);
  const [openContact, setOpenContact] = useState(false);
  const cookie = Cookie.getCookie();
  const [state, setState] = useSetState({
    isMoveOne: false,
    isMoveTwo: false
  });

  useTimeout(() => {
    observerFn();
  }, 500);

  let pageWidth = window.innerWidth;

  useEffect(() => {
    if(cookie) {
      getUserInfo();
    }
  }, []);

  const observerFn = () => {
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if(entry.isIntersecting) {
          if(entry.target.id === 'ServiceWarp-ssjskcjs') {
            setState({ isMoveTwo: true });
          } else if(entry.target.id === 'Highlights-shinkk88') {
            setState({ isMoveOne: true });
          }
        } else {
          if(entry.target.id === 'ServiceWarp-ssjskcjs') {
            setState({ isMoveTwo: false });
          } else if(entry.target.id === 'Highlights-shinkk88') {
            setState({ isMoveOne: false });
          }
        }
      });
    }, {});
    const ServiceWarp = document.getElementById('ServiceWarp-ssjskcjs');
    const Highlights = document.getElementById('Highlights-shinkk88');
    ServiceWarp && observer.observe(ServiceWarp);
    Highlights && observer.observe(Highlights);
  };

  async function getUserInfo() {
    const { hasCompanyIp } = await common.getIP();
    return actions.user.getUserInfo(hasCompanyIp);
  }

  return (
    <React.Fragment>
      {pageWidth > SCREEN_WIDTH.MOBILEWDITH ?
        <Scrollbar key={history.location.key} className="ai_book-home">
          <div className="ai_book_bg">
            <div className="ai_book-home-header">
              <div className="main header-wrap dis-flex flex-justify">
                {
                  cookie ?
                    <Header /> :
                <>
                  <h1 className="header-logo">易  听书</h1>
                  <div className="header-actions">
                    <Button
                      type="primary"
                      size="large"
                      onClick={() => {
                        setOpenLogin(true);
                      }}
                    >登录</Button>
                  </div>
                </>
                }
              </div>
            </div>
            <div className="ai_book-home-banner">
              <div className="ai_book-home-content dis-flex flex-justify banner-wrap">
                <img className="left" src="https://oss.5rs.me/oss/uploadfe/png/35d8cc90378546a7a2e766f52503a336.png" />
                <img className="right" src="https://oss.5rs.me/oss/uploadfe/png/45d4c71899134bcf4f4933db1c4f060c.png" />
                <Button
                  className="entry"
                  type="primary"
                  style={{ width: 160, height: 48 }}
                  size="large"
                  onClick={() => {
                    if(cookie) {
                      // 当前项目进入  需要使用接口更新empId
                      audiobookapi.getEmployeeIdByAdviserIdAndJobId().then(res => {
                        if(res) {
                          localStorage.setItem('empId', res);
                        } else {
                          localStorage.setItem('empId', '');
                        }
                      });
                      history.push(PAGES.HOME);
                    } else {
                      setOpenLogin(true);
                    }
                  }}
                >立即体验</Button>
              </div>
            </div>
            <div className="ai_book-home-highlights ai_book-home-content" id="Highlights-shinkk88">
              <div className={classNames('highlights-image', { 'active': state.isMoveOne })} />
              <div className="highlights-content">
                <div className="highlights-content-title">文本转<span>真人</span>语音</div>
                <div className="highlights-content-tips">
                  <div className="highlights-content-tips-li">一键将文本生成为自然流畅、高表现力的语音</div>
                  <div className="highlights-content-tips-li">智能断句、高度拟人</div>
                  <div className="highlights-content-tips-li">无限接近真人播音员</div>
                  <div className="highlights-content-tips-li">适用于有声书、新闻、短视频制作等场景</div>
                </div>
              </div>
            </div>
            <ServiceWarp isMove={state.isMoveTwo} />
            <DubWarp />
            <div className="ai_book-home-contact ai_book-home-content">
              <div className="contact-wrapper-left">
                <div>
                  <img src="https://oss.5rs.me/oss/uploadfe/png/4ca6b13d6e1b4046ec188d722150f966.png" />
                </div>
                <p>微信扫码 添加专属客服</p>
              </div>
              <div className="contact-wrapper-right">
                <h3>联系我们</h3>
                <p>随时为您解答问题，提供优质有声书定制服务！</p>
                <button onClick={() => setOpenContact(true)}>欢迎咨询了解 <i className="ic ic-arrow-right" /></button>
              </div>
            </div>
            <div className="ai_book-home-footer">
              <p>易 · 听书</p>
              <p>Copyright © 2014-2024 中国 武汉理工数字传播工程有限公司</p>
            </div>
          </div>
        </Scrollbar> :
        <Mobile />}

      <LoginModal
        open={openLogin}
        onCancel={() => setOpenLogin(false)}
      />
      <ContactModal
        open={openContact}
        onCancel={() => setOpenContact(false)}
      />
    </React.Fragment>
  );
}
